const testisProcessor=(element)=>
{
let assembledElement=""

if (element["Texture:"] !== "")
    {
    assembledElement += ` ${element["Texture:"].toLowerCase()},` 
    }

if (element["Pain:"] !== "")
    {
    assembledElement += ` ${element["Pain:"].toLowerCase()},` 
    }

if (element["Tenderness:"] !== "")
    {
    assembledElement += ` ${element["Tenderness:"].toLowerCase()},` 
    }

if (element["Side"] !== "")
    {
    assembledElement += ` ${element["Side"].toLowerCase()}` 
    
        if (element["Side"] !=="Bilateral")
            {
            assembledElement += " sided"
            }
    }

assembledElement += " testicular change"

if (element["Involving"].length > 0)
    { 
    assembledElement += " involving the"
    assembledElement += ` ${element["Involving"][0].toLowerCase()}` 
    if (element["Involving"].length >1)
        assembledElement += ` and the ${element["Involving"][1].toLowerCase() }`
    }

if (element["Consistency_change:"] !== "")
    {
    assembledElement += " which"
    if (element["Present_for_several:"] !== "")
        {
        assembledElement += ((element["Involving"].length >1) ? " have been" : " has been")
        }
    else
        if (element["Present_for_several:"] !== "")
        {
        assembledElement += ((element["Involving"].length >1) ? " are" : " is")
        }

    switch (element["Consistency_change:"])
            {
            case "Harder":
                assembledElement += " harder than"
                break

            case "Softer":
                assembledElement += " softer than"
                break

            default:
            }
    assembledElement += " normal consistency"
        }

if (element["Present_for_several:"] !== "")
    {
    assembledElement += ` for several ${element["Present_for_several:"].toLowerCase()}`
    }


return (assembledElement)
}

export default testisProcessor